// NHL supplements — extended valuation history (2004-2018) + factor narratives
// Sources: Forbes annual NHL valuations 2004-2018, Sportico, ESPN, SBJ
// Note: Forbes NHL valuations published annually since 2004; values in $B
// Expansion teams: Vegas (2017, $500M), Seattle Kraken (2021, $650M), Utah Hockey Club (relocated from Arizona Coyotes 2024)
export const nhlSupplements = {

  "Boston Bruins": {
    extendedValuationHistory: [
      { year: 2004, value: 0.146, source: "Forbes" },
      { year: 2005, value: 0.184, source: "Forbes" },
      { year: 2006, value: 0.206, source: "Forbes" },
      { year: 2007, value: 0.232, source: "Forbes" },
      { year: 2008, value: 0.271, source: "Forbes" },
      { year: 2009, value: 0.302, source: "Forbes" },
      { year: 2010, value: 0.325, source: "Forbes" },
      { year: 2011, value: 0.348, source: "Forbes" },
      { year: 2012, value: 0.450, source: "Forbes" },
      { year: 2013, value: 0.600, source: "Forbes" },
      { year: 2014, value: 0.750, source: "Forbes" },
      { year: 2015, value: 0.800, source: "Forbes" },
      { year: 2016, value: 0.890, source: "Forbes" },
      { year: 2017, value: 0.925, source: "Forbes" },
      { year: 2018, value: 1.00, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bruins receive ~$19M/yr from US national TV; 20% NESN equity stake provides incremental media income that survived the Bally/Diamond RSN collapse.",
      stadium: "TD Garden (1995) owned by Delaware North (Jacobs family); Bruins are tenants alongside Celtics with minority equity in arena ownership vehicle.",
      brand: "Original Six franchise with deep New England identity and 6 Stanley Cups; sustained sellout streak; loyalty among the league's strongest.",
      marketSize: "Boston DMA #10; no NHL competition; corporate base supports premium pricing despite mid-sized market.",
      onField: "Pastrnak 8yr/$90M extension anchors top line; consistent playoff contender but no Cups since 2011; aging core in transition."
    }
  },

  "Buffalo Sabres": {
    extendedValuationHistory: [
      { year: 2004, value: 0.094, source: "Forbes" },
      { year: 2005, value: 0.106, source: "Forbes" },
      { year: 2006, value: 0.131, source: "Forbes" },
      { year: 2007, value: 0.151, source: "Forbes" },
      { year: 2008, value: 0.169, source: "Forbes" },
      { year: 2009, value: 0.176, source: "Forbes" },
      { year: 2010, value: 0.169, source: "Forbes" },
      { year: 2011, value: 0.180, source: "Forbes" },
      { year: 2012, value: 0.225, source: "Forbes" },
      { year: 2013, value: 0.250, source: "Forbes" },
      { year: 2014, value: 0.270, source: "Forbes" },
      { year: 2015, value: 0.305, source: "Forbes" },
      { year: 2016, value: 0.350, source: "Forbes" },
      { year: 2017, value: 0.385, source: "Forbes" },
      { year: 2018, value: 0.400, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; MSG Western New York carries games but local market is small and constrained by Toronto market overlap.",
      stadium: "KeyBank Center (1996) county-owned; Sabres tenant under lease through 2031; Pegula-led discussions for downtown replacement remain unresolved.",
      brand: "Solid heritage in upstate NY but limited national presence; 13-year playoff drought through 2023 eroded engagement.",
      marketSize: "Buffalo DMA #54 — among the smallest NHL markets; cross-border Canadian fan overlap with Toronto cuts both ways.",
      onField: "Tage Thompson 7yr/$50M anchors emerging young core; ended playoff drought 2024 but franchise remains in rebuild posture."
    }
  },

  "Detroit Red Wings": {
    extendedValuationHistory: [
      { year: 2004, value: 0.248, source: "Forbes" },
      { year: 2005, value: 0.266, source: "Forbes" },
      { year: 2006, value: 0.288, source: "Forbes" },
      { year: 2007, value: 0.293, source: "Forbes" },
      { year: 2008, value: 0.303, source: "Forbes" },
      { year: 2009, value: 0.323, source: "Forbes" },
      { year: 2010, value: 0.337, source: "Forbes" },
      { year: 2011, value: 0.346, source: "Forbes" },
      { year: 2012, value: 0.395, source: "Forbes" },
      { year: 2013, value: 0.470, source: "Forbes" },
      { year: 2014, value: 0.570, source: "Forbes" },
      { year: 2015, value: 0.625, source: "Forbes" },
      { year: 2016, value: 0.700, source: "Forbes" },
      { year: 2017, value: 0.815, source: "Forbes" },
      { year: 2018, value: 0.900, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports Detroit RSN exposure remains a risk; Ilitch Holdings broader media footprint provides some shelter.",
      stadium: "Little Caesars Arena (2017) cost $863M with $324M public / $539M Ilitch private financing; Red Wings own operating rights and capture full venue economics.",
      brand: "Original Six franchise with 11 Stanley Cups; one of NHL's most globally recognized brands; current rebuild has dimmed but not erased equity.",
      marketSize: "Detroit DMA #14; deep hockey culture; District Detroit development around the arena adds ancillary real estate value.",
      onField: "Dylan Larkin 8yr/$69.6M anchors rebuild; multi-year playoff absence; 'Yzerplan' rebuild approaching contention phase."
    }
  },

  "Florida Panthers": {
    extendedValuationHistory: [
      { year: 2004, value: 0.108, source: "Forbes" },
      { year: 2005, value: 0.117, source: "Forbes" },
      { year: 2006, value: 0.131, source: "Forbes" },
      { year: 2007, value: 0.142, source: "Forbes" },
      { year: 2008, value: 0.156, source: "Forbes" },
      { year: 2009, value: 0.156, source: "Forbes" },
      { year: 2010, value: 0.163, source: "Forbes" },
      { year: 2011, value: 0.162, source: "Forbes" },
      { year: 2012, value: 0.170, source: "Forbes" },
      { year: 2013, value: 0.180, source: "Forbes" },
      { year: 2014, value: 0.190, source: "Forbes" },
      { year: 2015, value: 0.205, source: "Forbes" },
      { year: 2016, value: 0.235, source: "Forbes" },
      { year: 2017, value: 0.295, source: "Forbes" },
      { year: 2018, value: 0.310, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports Florida RSN exposure with relatively modest local TV figures vs. legacy markets.",
      stadium: "Amerant Bank Arena (1998) owned by Broward County; Panthers are tenants but capture incremental revenue through 2024 Cup-driven attendance and naming rights renewals.",
      brand: "Sun Belt franchise transformed by back-to-back Stanley Cup Finals (2023, 2024) and 2024 championship; brand value re-rating still ongoing.",
      marketSize: "Miami-Fort Lauderdale DMA #16; competes with Heat for sports calendar share but unique winter sport offering.",
      onField: "2024 Stanley Cup champions; Matthew Tkachuk 8yr/$76M and Sasha Barkov long-term core; in clear contention window."
    }
  },

  "Montreal Canadiens": {
    extendedValuationHistory: [
      { year: 2004, value: 0.145, source: "Forbes" },
      { year: 2005, value: 0.159, source: "Forbes" },
      { year: 2006, value: 0.183, source: "Forbes" },
      { year: 2007, value: 0.220, source: "Forbes" },
      { year: 2008, value: 0.252, source: "Forbes" },
      { year: 2009, value: 0.302, source: "Forbes" },
      { year: 2010, value: 0.339, source: "Forbes" },
      { year: 2011, value: 0.408, source: "Forbes" },
      { year: 2012, value: 0.445, source: "Forbes" },
      { year: 2013, value: 0.575, source: "Forbes" },
      { year: 2014, value: 0.775, source: "Forbes" },
      { year: 2015, value: 1.18, source: "Forbes" },
      { year: 2016, value: 1.18, source: "Forbes" },
      { year: 2017, value: 1.25, source: "Forbes" },
      { year: 2018, value: 1.30, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian premium: substantial Rogers Sportsnet + RDS/TVA Sports French-language rights on top of $19M US national share; bilingual media franchise.",
      stadium: "Bell Centre (1996) 100% privately financed and team-owned; largest NHL arena (21,105); Molson family also owns Evenko (concert promoter), capturing non-hockey events.",
      brand: "Canadiens are NHL's most decorated franchise with 24 Stanley Cups; Original Six; deeply embedded in Quebec cultural identity and Canadian hockey heritage.",
      marketSize: "Montreal DMA #2 in Canada; only NHL franchise; bilingual market with passionate, paying fanbase tolerant of premium pricing.",
      onField: "Caufield/Suzuki/Hutson rebuild core showing acceleration; no Cup since 1993 (longest current drought among Original Six); rebuild finally approaching contention."
    }
  },

  "Ottawa Senators": {
    extendedValuationHistory: [
      { year: 2004, value: 0.106, source: "Forbes" },
      { year: 2005, value: 0.117, source: "Forbes" },
      { year: 2006, value: 0.157, source: "Forbes" },
      { year: 2007, value: 0.179, source: "Forbes" },
      { year: 2008, value: 0.196, source: "Forbes" },
      { year: 2009, value: 0.207, source: "Forbes" },
      { year: 2010, value: 0.190, source: "Forbes" },
      { year: 2011, value: 0.201, source: "Forbes" },
      { year: 2012, value: 0.255, source: "Forbes" },
      { year: 2013, value: 0.310, source: "Forbes" },
      { year: 2014, value: 0.355, source: "Forbes" },
      { year: 2015, value: 0.400, source: "Forbes" },
      { year: 2016, value: 0.420, source: "Forbes" },
      { year: 2017, value: 0.430, source: "Forbes" },
      { year: 2018, value: 0.435, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian national TV upside via Rogers/Bell + ~$19M US share; smaller market RSN opportunity than Toronto/Montreal but stable.",
      stadium: "Canadian Tire Centre (1996) team-owned but in Kanata suburb — proposed downtown LeBreton Flats stadium under Andlauer ownership is the major valuation lever.",
      brand: "Modern (1992) franchise without deep heritage; passionate local fanbase; 2007 Stanley Cup Final but no titles.",
      marketSize: "Ottawa DMA among smaller Canadian markets; competes for fan share with Toronto media spillover; new-arena downtown move would unlock meaningful upside.",
      onField: "Brady Tkachuk 7yr/$57.5M is franchise face; emerging young core; back to playoffs in 2025 after multi-year absence."
    }
  },

  "Tampa Bay Lightning": {
    extendedValuationHistory: [
      { year: 2004, value: 0.146, source: "Forbes" },
      { year: 2005, value: 0.157, source: "Forbes" },
      { year: 2006, value: 0.155, source: "Forbes" },
      { year: 2007, value: 0.180, source: "Forbes" },
      { year: 2008, value: 0.199, source: "Forbes" },
      { year: 2009, value: 0.190, source: "Forbes" },
      { year: 2010, value: 0.174, source: "Forbes" },
      { year: 2011, value: 0.181, source: "Forbes" },
      { year: 2012, value: 0.230, source: "Forbes" },
      { year: 2013, value: 0.240, source: "Forbes" },
      { year: 2014, value: 0.295, source: "Forbes" },
      { year: 2015, value: 0.330, source: "Forbes" },
      { year: 2016, value: 0.385, source: "Forbes" },
      { year: 2017, value: 0.510, source: "Forbes" },
      { year: 2018, value: 0.625, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports Sun → Scripps Sports transition; sun-belt market with growing engagement post-back-to-back Cups.",
      stadium: "Amalie Arena (1996); Vinik invested $35M+ in upgrades; Water Street Tampa $3.5B mixed-use development around arena is major ancillary value driver.",
      brand: "Modern franchise transformed by back-to-back Cups (2020, 2021); Vinik-era brand reinvention created sun-belt model franchise.",
      marketSize: "Tampa-St. Pete DMA #14; meaningful corporate and snowbird base; sun-belt growth narrative supports continued market expansion.",
      onField: "Kucherov/Point/Vasilevskiy core remains contention-grade; back-to-back Cup window now closing but Cup-validated culture sustains."
    }
  },

  "Toronto Maple Leafs": {
    extendedValuationHistory: [
      { year: 2004, value: 0.280, source: "Forbes" },
      { year: 2005, value: 0.325, source: "Forbes" },
      { year: 2006, value: 0.332, source: "Forbes" },
      { year: 2007, value: 0.413, source: "Forbes" },
      { year: 2008, value: 0.448, source: "Forbes" },
      { year: 2009, value: 0.470, source: "Forbes" },
      { year: 2010, value: 0.505, source: "Forbes" },
      { year: 2011, value: 0.521, source: "Forbes" },
      { year: 2012, value: 0.521, source: "Forbes" },
      { year: 2013, value: 1.00, source: "Forbes" },
      { year: 2014, value: 1.15, source: "Forbes" },
      { year: 2015, value: 1.30, source: "Forbes" },
      { year: 2016, value: 1.30, source: "Forbes" },
      { year: 2017, value: 1.40, source: "Forbes" },
      { year: 2018, value: 1.45, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian crown jewel — Rogers owns 75% of MLSE, providing unique vertical integration with Sportsnet (national rights holder); largest Canadian TV revenue base.",
      stadium: "Scotiabank Arena (1999) team-owned via MLSE; shared with Raptors (NBA); $40M Scotiabank naming deal; major revenue from concerts and Raptors co-tenancy.",
      brand: "Original Six and most valuable NHL franchise; 13 Stanley Cups; deepest hockey market in North America; brand transcends on-ice results.",
      marketSize: "Toronto DMA largest in Canada; sole NHL team; affluent corporate base supports league-leading ticket pricing and sponsorship revenue.",
      onField: "Auston Matthews $13.25M AAV anchors elite core; 57-year Cup drought is the franchise narrative; first round wins in 2023, 2025 not enough yet."
    }
  },

  "Carolina Hurricanes": {
    extendedValuationHistory: [
      { year: 2004, value: 0.107, source: "Forbes" },
      { year: 2005, value: 0.105, source: "Forbes" },
      { year: 2006, value: 0.156, source: "Forbes" },
      { year: 2007, value: 0.183, source: "Forbes" },
      { year: 2008, value: 0.202, source: "Forbes" },
      { year: 2009, value: 0.198, source: "Forbes" },
      { year: 2010, value: 0.176, source: "Forbes" },
      { year: 2011, value: 0.186, source: "Forbes" },
      { year: 2012, value: 0.205, source: "Forbes" },
      { year: 2013, value: 0.220, source: "Forbes" },
      { year: 2014, value: 0.230, source: "Forbes" },
      { year: 2015, value: 0.225, source: "Forbes" },
      { year: 2016, value: 0.230, source: "Forbes" },
      { year: 2017, value: 0.290, source: "Forbes" },
      { year: 2018, value: 0.370, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; team-owned regional broadcast (RSN-collapse-immune); innovative direct streaming approach under Dundon.",
      stadium: "Lenovo Center (1999) state-owned; Hurricanes hold 80-acre development rights around the arena, providing unique real-estate-driven valuation upside.",
      brand: "Modern Sun Belt franchise (relocated from Hartford 1997); 2006 Cup; 117+ game sellout streak post-Dundon turnaround; growing southeast presence.",
      marketSize: "Raleigh-Durham DMA #25; non-traditional hockey market that has grown sharply; tech/research corporate base supports premium pricing.",
      onField: "Sebastian Aho 8yr/$78M anchors elite possession-driven team; deep playoff appearances since 2019 but no Cup Finals since 2006."
    }
  },

  "Columbus Blue Jackets": {
    extendedValuationHistory: [
      { year: 2004, value: 0.114, source: "Forbes" },
      { year: 2005, value: 0.116, source: "Forbes" },
      { year: 2006, value: 0.137, source: "Forbes" },
      { year: 2007, value: 0.157, source: "Forbes" },
      { year: 2008, value: 0.171, source: "Forbes" },
      { year: 2009, value: 0.171, source: "Forbes" },
      { year: 2010, value: 0.157, source: "Forbes" },
      { year: 2011, value: 0.148, source: "Forbes" },
      { year: 2012, value: 0.175, source: "Forbes" },
      { year: 2013, value: 0.195, source: "Forbes" },
      { year: 2014, value: 0.200, source: "Forbes" },
      { year: 2015, value: 0.230, source: "Forbes" },
      { year: 2016, value: 0.260, source: "Forbes" },
      { year: 2017, value: 0.280, source: "Forbes" },
      { year: 2018, value: 0.300, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports Ohio exposure; smallest TV market among current NHL franchises.",
      stadium: "Nationwide Arena (2000) became publicly owned in 2012 (acquired by city); Blue Jackets pay reduced rent under restructured deal.",
      brand: "Modern (2000) expansion franchise without deep heritage; minimal national presence; loyal local fanbase.",
      marketSize: "Columbus DMA #32; non-traditional hockey market; competes with Ohio State football for sports-share-of-wallet.",
      onField: "Limited recent playoff success; current roster in transition; Werenski franchise defenseman; structurally challenged by market and revenue base."
    }
  },

  "New Jersey Devils": {
    extendedValuationHistory: [
      { year: 2004, value: 0.137, source: "Forbes" },
      { year: 2005, value: 0.157, source: "Forbes" },
      { year: 2006, value: 0.182, source: "Forbes" },
      { year: 2007, value: 0.207, source: "Forbes" },
      { year: 2008, value: 0.218, source: "Forbes" },
      { year: 2009, value: 0.205, source: "Forbes" },
      { year: 2010, value: 0.181, source: "Forbes" },
      { year: 2011, value: 0.165, source: "Forbes" },
      { year: 2012, value: 0.195, source: "Forbes" },
      { year: 2013, value: 0.230, source: "Forbes" },
      { year: 2014, value: 0.265, source: "Forbes" },
      { year: 2015, value: 0.320, source: "Forbes" },
      { year: 2016, value: 0.370, source: "Forbes" },
      { year: 2017, value: 0.420, source: "Forbes" },
      { year: 2018, value: 0.485, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; MSG Networks regional carrier shared with Knicks/Rangers/Islanders; HBSE multi-property scale provides leverage.",
      stadium: "Prudential Center (2007) team-owned; HBSE captures full venue economics including non-hockey events.",
      brand: "Modern franchise with three Cups (1995, 2000, 2003); strong New Jersey identity but limited national reach; HBSE rebrand drove engagement.",
      marketSize: "New York DMA #1 but competes with Rangers and Islanders; New Jersey-specific subset of metro fans is loyal but smaller than Manhattan.",
      onField: "Jack Hughes 8yr/$78M and Hischier 7yr/$57.75M anchor young elite core; injury luck the swing factor for Cup contention."
    }
  },

  "New York Islanders": {
    extendedValuationHistory: [
      { year: 2004, value: 0.117, source: "Forbes" },
      { year: 2005, value: 0.123, source: "Forbes" },
      { year: 2006, value: 0.139, source: "Forbes" },
      { year: 2007, value: 0.149, source: "Forbes" },
      { year: 2008, value: 0.163, source: "Forbes" },
      { year: 2009, value: 0.149, source: "Forbes" },
      { year: 2010, value: 0.137, source: "Forbes" },
      { year: 2011, value: 0.149, source: "Forbes" },
      { year: 2012, value: 0.155, source: "Forbes" },
      { year: 2013, value: 0.160, source: "Forbes" },
      { year: 2014, value: 0.195, source: "Forbes" },
      { year: 2015, value: 0.385, source: "Forbes" },
      { year: 2016, value: 0.395, source: "Forbes" },
      { year: 2017, value: 0.395, source: "Forbes" },
      { year: 2018, value: 0.435, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; MSG Networks shared regional carriage; UBS naming rights deal ($175M) provides key sponsorship anchor.",
      stadium: "UBS Arena (2021) at Belmont Park — $1.1B 100% privately financed by Ledecky/Malkin; team-owned with full venue economics; major upgrade from Nassau Coliseum era.",
      brand: "1980s dynasty (4 straight Cups 1980-83) provides heritage; brand has been rebuilding since the Coliseum exile years.",
      marketSize: "New York DMA #1 — but Long Island subset is the primary base; Brooklyn/Manhattan reach now improved with UBS Arena location.",
      onField: "Mat Barzal/Noah Dobson core; Lou Lamoriello-era was defense-first; Patrick Roy era seeking offensive uplift; Cup ambitions limited."
    }
  },

  "New York Rangers": {
    extendedValuationHistory: [
      { year: 2004, value: 0.272, source: "Forbes" },
      { year: 2005, value: 0.282, source: "Forbes" },
      { year: 2006, value: 0.326, source: "Forbes" },
      { year: 2007, value: 0.365, source: "Forbes" },
      { year: 2008, value: 0.411, source: "Forbes" },
      { year: 2009, value: 0.416, source: "Forbes" },
      { year: 2010, value: 0.461, source: "Forbes" },
      { year: 2011, value: 0.507, source: "Forbes" },
      { year: 2012, value: 0.750, source: "Forbes" },
      { year: 2013, value: 0.850, source: "Forbes" },
      { year: 2014, value: 1.10, source: "Forbes" },
      { year: 2015, value: 1.20, source: "Forbes" },
      { year: 2016, value: 1.25, source: "Forbes" },
      { year: 2017, value: 1.45, source: "Forbes" },
      { year: 2018, value: 1.55, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "MSG Networks (Dolan-owned) provides full RSN ownership — RSN-collapse-immune; ~$19M US national share; among NHL's strongest combined media position.",
      stadium: "Madison Square Garden — iconic, team-owned via MSG Sports; deliberately no naming rights to preserve brand equity; shared with Knicks but full hockey economics.",
      brand: "Original Six in the world's most valuable sports market; 'Broadway Blueshirts' brand carries premium pricing and sponsorship power; 4 Stanley Cups.",
      marketSize: "New York DMA #1 — largest US sports market; broad corporate sponsorship base; affluent fanbase tolerates highest ticket prices in NHL.",
      onField: "Adam Fox 7yr/$66.5M, Shesterkin 4yr/$46M anchor contender core; recent Eastern Conference Final appearance; no Cup since 1994."
    }
  },

  "Philadelphia Flyers": {
    extendedValuationHistory: [
      { year: 2004, value: 0.205, source: "Forbes" },
      { year: 2005, value: 0.243, source: "Forbes" },
      { year: 2006, value: 0.261, source: "Forbes" },
      { year: 2007, value: 0.275, source: "Forbes" },
      { year: 2008, value: 0.275, source: "Forbes" },
      { year: 2009, value: 0.276, source: "Forbes" },
      { year: 2010, value: 0.273, source: "Forbes" },
      { year: 2011, value: 0.301, source: "Forbes" },
      { year: 2012, value: 0.355, source: "Forbes" },
      { year: 2013, value: 0.390, source: "Forbes" },
      { year: 2014, value: 0.510, source: "Forbes" },
      { year: 2015, value: 0.660, source: "Forbes" },
      { year: 2016, value: 0.720, source: "Forbes" },
      { year: 2017, value: 0.740, source: "Forbes" },
      { year: 2018, value: 0.775, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; NBC Sports Philadelphia regional intracompany RSN; Comcast Spectacor parent ownership provides RSN insulation.",
      stadium: "Wells Fargo Center (1996, renamed to Xfinity Mobile Arena 2025); Comcast-owned via Spectacor; new $1.3B arena planned for 2030 jointly with 76ers.",
      brand: "1970s 'Broad Street Bullies' identity; back-to-back Cups (1974, 1975) but none since; passionate East Coast fanbase.",
      marketSize: "Philadelphia DMA #4; competes with 76ers (shared building) and Eagles for sports calendar; no Cups since 1975.",
      onField: "Travis Konecny core; current rebuild after multiple years out of contention; modest playoff ambitions near-term."
    }
  },

  "Pittsburgh Penguins": {
    extendedValuationHistory: [
      { year: 2004, value: 0.114, source: "Forbes" },
      { year: 2005, value: 0.107, source: "Forbes" },
      { year: 2006, value: 0.119, source: "Forbes" },
      { year: 2007, value: 0.155, source: "Forbes" },
      { year: 2008, value: 0.195, source: "Forbes" },
      { year: 2009, value: 0.222, source: "Forbes" },
      { year: 2010, value: 0.235, source: "Forbes" },
      { year: 2011, value: 0.264, source: "Forbes" },
      { year: 2012, value: 0.288, source: "Forbes" },
      { year: 2013, value: 0.480, source: "Forbes" },
      { year: 2014, value: 0.565, source: "Forbes" },
      { year: 2015, value: 0.570, source: "Forbes" },
      { year: 2016, value: 0.660, source: "Forbes" },
      { year: 2017, value: 0.750, source: "Forbes" },
      { year: 2018, value: 0.625, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; SportsNet Pittsburgh JV (Penguins/Pirates/RSE) survived Diamond collapse; local rights dynamics uncertain.",
      stadium: "PPG Paints Arena (2010) publicly owned by Sports & Exhibition Authority; Penguins capture key revenue but not real estate upside; recent attendance declines.",
      brand: "Two-time dynasty franchise (Lemieux 1990s, Crosby/Malkin late 2000s-2010s); 5 Stanley Cups; one of NHL's most valuable brands tied to Crosby era.",
      marketSize: "Pittsburgh DMA #26; mid-size market; football-first city but hockey deeply established.",
      onField: "Crosby 2yr/$17.4M extension at age 38; Malkin and Letang aging out of contention window; FSG-to-Hoffmann sale Dec 2025 marks ownership transition."
    }
  },

  "Washington Capitals": {
    extendedValuationHistory: [
      { year: 2004, value: 0.110, source: "Forbes" },
      { year: 2005, value: 0.122, source: "Forbes" },
      { year: 2006, value: 0.135, source: "Forbes" },
      { year: 2007, value: 0.145, source: "Forbes" },
      { year: 2008, value: 0.160, source: "Forbes" },
      { year: 2009, value: 0.183, source: "Forbes" },
      { year: 2010, value: 0.197, source: "Forbes" },
      { year: 2011, value: 0.225, source: "Forbes" },
      { year: 2012, value: 0.250, source: "Forbes" },
      { year: 2013, value: 0.290, source: "Forbes" },
      { year: 2014, value: 0.350, source: "Forbes" },
      { year: 2015, value: 0.477, source: "Forbes" },
      { year: 2016, value: 0.625, source: "Forbes" },
      { year: 2017, value: 0.700, source: "Forbes" },
      { year: 2018, value: 0.825, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Monumental Sports Network is fully owned RSN — Leonsis pioneer of vertical integration; RSN-collapse-immune.",
      stadium: "Capital One Arena (1997) Monumental-owned; shared with Wizards (NBA); $515M DC arena renovation deal locks teams in DC through ~2050.",
      brand: "Ovechkin era brand transformation; 2018 Stanley Cup; Monumental ecosystem amplifies regional presence.",
      marketSize: "Washington DMA #9; affluent corporate base; Leonsis Monumental empire (Caps/Wizards/Mystics/Capital One Arena) creates cross-property leverage.",
      onField: "Ovechkin 5yr/$47.5M deal ends 2025-26 — historic all-time goals chase already complete; rebuild begins post-Ovechkin."
    }
  },

  "Utah Hockey Club": {
    extendedValuationHistory: [
      { year: 2004, value: 0.100, source: "Forbes (Phoenix Coyotes)" },
      { year: 2005, value: 0.110, source: "Forbes (Phoenix Coyotes)" },
      { year: 2006, value: 0.135, source: "Forbes (Phoenix Coyotes)" },
      { year: 2007, value: 0.142, source: "Forbes (Phoenix Coyotes)" },
      { year: 2008, value: 0.142, source: "Forbes (Phoenix Coyotes)" },
      { year: 2009, value: 0.135, source: "Forbes (Phoenix Coyotes)" },
      { year: 2010, value: 0.134, source: "Forbes (Phoenix Coyotes)" },
      { year: 2011, value: 0.117, source: "Forbes (Phoenix Coyotes)" },
      { year: 2012, value: 0.134, source: "Forbes (Phoenix Coyotes)" },
      { year: 2013, value: 0.170, source: "Forbes (Phoenix Coyotes)" },
      { year: 2014, value: 0.225, source: "Forbes (Arizona Coyotes)" },
      { year: 2015, value: 0.205, source: "Forbes (Arizona Coyotes)" },
      { year: 2016, value: 0.240, source: "Forbes (Arizona Coyotes)" },
      { year: 2017, value: 0.300, source: "Forbes (Arizona Coyotes)" },
      { year: 2018, value: 0.310, source: "Forbes (Arizona Coyotes)" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Salt Lake City regional broadcast rights early-stage; Smith Entertainment Group holistic media bundling potential significant.",
      stadium: "Delta Center (1991) — shared with Utah Jazz (NBA, also Smith-owned); $900M public-funded renovation underway; new dedicated NHL arena planning.",
      brand: "Brand reset opportunity post-2024 relocation from Arizona; permanent Utah Hockey Club identity forthcoming; clean slate for franchise narrative.",
      marketSize: "Salt Lake DMA #28 — non-traditional hockey market but rapidly growing; only major-league hockey in Mountain West region; tech/finance corporate base.",
      onField: "Clayton Keller core anchored relocation; Logan Cooley emerging; Smith-funded payroll commitment; rebuild completing transition."
    }
  },

  "Chicago Blackhawks": {
    extendedValuationHistory: [
      { year: 2004, value: 0.142, source: "Forbes" },
      { year: 2005, value: 0.151, source: "Forbes" },
      { year: 2006, value: 0.156, source: "Forbes" },
      { year: 2007, value: 0.179, source: "Forbes" },
      { year: 2008, value: 0.205, source: "Forbes" },
      { year: 2009, value: 0.231, source: "Forbes" },
      { year: 2010, value: 0.300, source: "Forbes" },
      { year: 2011, value: 0.306, source: "Forbes" },
      { year: 2012, value: 0.350, source: "Forbes" },
      { year: 2013, value: 0.625, source: "Forbes" },
      { year: 2014, value: 0.825, source: "Forbes" },
      { year: 2015, value: 0.925, source: "Forbes" },
      { year: 2016, value: 1.00, source: "Forbes" },
      { year: 2017, value: 1.05, source: "Forbes" },
      { year: 2018, value: 1.05, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; NBC Sports Chicago intracompany RSN with Reinsdorf properties; recent rebuild has tempered local TV momentum.",
      stadium: "United Center (1994) 50/50 owned with Reinsdorf (Bulls); shared with Bulls; $7B mixed-use development district plan major value lever.",
      brand: "Original Six franchise; recent dynasty era (3 Cups 2010, 2013, 2015) revived national prominence; one of NHL's iconic crests and merchandise franchises.",
      marketSize: "Chicago DMA #3; massive corporate base; competes with Bulls (shared arena), Cubs, Bears for sports calendar share.",
      onField: "Connor Bedard 2023 #1 pick is generational; ELC at $950K through 2025-26 then mega-extension; rebuild approaching contention phase."
    }
  },

  "Colorado Avalanche": {
    extendedValuationHistory: [
      { year: 2004, value: 0.163, source: "Forbes" },
      { year: 2005, value: 0.198, source: "Forbes" },
      { year: 2006, value: 0.213, source: "Forbes" },
      { year: 2007, value: 0.198, source: "Forbes" },
      { year: 2008, value: 0.193, source: "Forbes" },
      { year: 2009, value: 0.198, source: "Forbes" },
      { year: 2010, value: 0.183, source: "Forbes" },
      { year: 2011, value: 0.188, source: "Forbes" },
      { year: 2012, value: 0.222, source: "Forbes" },
      { year: 2013, value: 0.260, source: "Forbes" },
      { year: 2014, value: 0.305, source: "Forbes" },
      { year: 2015, value: 0.360, source: "Forbes" },
      { year: 2016, value: 0.385, source: "Forbes" },
      { year: 2017, value: 0.400, source: "Forbes" },
      { year: 2018, value: 0.435, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Altitude Sports RSN fully owned by Kroenke — RSN-collapse-immune via vertical integration with Nuggets/Avalanche/Mammoth.",
      stadium: "Ball Arena (1999) team-owned via KSE; shared with Nuggets (NBA); KSE cross-property scale provides operational leverage.",
      brand: "1996-2001 dynasty era brand; 3 Stanley Cups (1996, 2001, 2022); Sakic legacy; modern revival under MacKinnon-Makar core.",
      marketSize: "Denver DMA #16; Mountain West regional reach; growing tech/cannabis corporate base.",
      onField: "MacKinnon 8yr/$100.8M is highest-paid NHL forward; Cale Makar 6yr/$54M; defending Cup window remains open."
    }
  },

  "Dallas Stars": {
    extendedValuationHistory: [
      { year: 2004, value: 0.207, source: "Forbes" },
      { year: 2005, value: 0.225, source: "Forbes" },
      { year: 2006, value: 0.224, source: "Forbes" },
      { year: 2007, value: 0.244, source: "Forbes" },
      { year: 2008, value: 0.240, source: "Forbes" },
      { year: 2009, value: 0.226, source: "Forbes" },
      { year: 2010, value: 0.197, source: "Forbes" },
      { year: 2011, value: 0.230, source: "Forbes" },
      { year: 2012, value: 0.240, source: "Forbes" },
      { year: 2013, value: 0.270, source: "Forbes" },
      { year: 2014, value: 0.345, source: "Forbes" },
      { year: 2015, value: 0.420, source: "Forbes" },
      { year: 2016, value: 0.500, source: "Forbes" },
      { year: 2017, value: 0.520, source: "Forbes" },
      { year: 2018, value: 0.560, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Victory+ direct streaming pioneer launched after Bally collapse — innovative DTC model that other franchises now study.",
      stadium: "American Airlines Center (2001); shared with Mavericks (NBA); team-owned operating rights; Victory Park development around arena.",
      brand: "Modern Sun Belt franchise (relocated from Minnesota 1993); 1999 Stanley Cup; Modano legacy; recent contention era rebuilding national presence.",
      marketSize: "Dallas-Fort Worth DMA #5 — massive Sun Belt market; competes with Cowboys/Mavs/Rangers; corporate scale supports premium pricing.",
      onField: "Heiskanen/Hintz core anchors contender; Robertson bridge contract impasse; multiple deep playoff runs without Final since 2020."
    }
  },

  "Minnesota Wild": {
    extendedValuationHistory: [
      { year: 2004, value: 0.146, source: "Forbes" },
      { year: 2005, value: 0.157, source: "Forbes" },
      { year: 2006, value: 0.180, source: "Forbes" },
      { year: 2007, value: 0.195, source: "Forbes" },
      { year: 2008, value: 0.198, source: "Forbes" },
      { year: 2009, value: 0.192, source: "Forbes" },
      { year: 2010, value: 0.193, source: "Forbes" },
      { year: 2011, value: 0.198, source: "Forbes" },
      { year: 2012, value: 0.225, source: "Forbes" },
      { year: 2013, value: 0.240, source: "Forbes" },
      { year: 2014, value: 0.275, source: "Forbes" },
      { year: 2015, value: 0.320, source: "Forbes" },
      { year: 2016, value: 0.355, source: "Forbes" },
      { year: 2017, value: 0.400, source: "Forbes" },
      { year: 2018, value: 0.420, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports North RSN exposure with bankruptcy fallout; FanDuel Sports Network transition adds uncertainty.",
      stadium: "Xcel Energy Center (2000) team-owned outright by Leipold; full venue economics including non-hockey events.",
      brand: "Modern (2000) franchise; 'State of Hockey' identity ties to deepest US hockey market; minimal national presence but strong local engagement.",
      marketSize: "Minneapolis-St. Paul DMA #15; deepest US hockey market by participation; passionate youth/college pipeline.",
      onField: "Kirill Kaprizov 8yr/$136M ($17M AAV) signed Sept 2025 — NHL record; consistent playoff team but limited Cup runs."
    }
  },

  "Nashville Predators": {
    extendedValuationHistory: [
      { year: 2004, value: 0.114, source: "Forbes" },
      { year: 2005, value: 0.114, source: "Forbes" },
      { year: 2006, value: 0.144, source: "Forbes" },
      { year: 2007, value: 0.155, source: "Forbes" },
      { year: 2008, value: 0.164, source: "Forbes" },
      { year: 2009, value: 0.169, source: "Forbes" },
      { year: 2010, value: 0.163, source: "Forbes" },
      { year: 2011, value: 0.166, source: "Forbes" },
      { year: 2012, value: 0.170, source: "Forbes" },
      { year: 2013, value: 0.205, source: "Forbes" },
      { year: 2014, value: 0.215, source: "Forbes" },
      { year: 2015, value: 0.250, source: "Forbes" },
      { year: 2016, value: 0.270, source: "Forbes" },
      { year: 2017, value: 0.500, source: "Forbes" },
      { year: 2018, value: 0.535, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports South exposure; smaller Tennessee TV market but growing engagement.",
      stadium: "Bridgestone Arena (1996) — downtown Nashville on Broadway; team-managed under public-ownership lease; one of NHL's loudest atmospheres.",
      brand: "Modern (1998) franchise; 2017 Stanley Cup Final run elevated national profile; Smashville identity with deep music-scene integration.",
      marketSize: "Nashville DMA #29 — fastest-growing US market; tourism flow into downtown via Broadway entertainment district.",
      onField: "Roman Josi/Filip Forsberg core aging; Stamkos signing Jul 2024; Predators in transition window."
    }
  },

  "St. Louis Blues": {
    extendedValuationHistory: [
      { year: 2004, value: 0.115, source: "Forbes" },
      { year: 2005, value: 0.116, source: "Forbes" },
      { year: 2006, value: 0.140, source: "Forbes" },
      { year: 2007, value: 0.157, source: "Forbes" },
      { year: 2008, value: 0.165, source: "Forbes" },
      { year: 2009, value: 0.165, source: "Forbes" },
      { year: 2010, value: 0.157, source: "Forbes" },
      { year: 2011, value: 0.151, source: "Forbes" },
      { year: 2012, value: 0.165, source: "Forbes" },
      { year: 2013, value: 0.185, source: "Forbes" },
      { year: 2014, value: 0.235, source: "Forbes" },
      { year: 2015, value: 0.270, source: "Forbes" },
      { year: 2016, value: 0.305, source: "Forbes" },
      { year: 2017, value: 0.370, source: "Forbes" },
      { year: 2018, value: 0.470, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally/FanDuel Sports Midwest RSN transition exposure; modest local TV revenue base.",
      stadium: "Enterprise Center (1994) city-owned; team operates under long-term lease; downtown location supports event traffic but no real estate upside.",
      brand: "Original 1967 expansion franchise; 2019 Stanley Cup ended 50+ year drought; passionate Midwest hockey market.",
      marketSize: "St. Louis DMA #21; football-first town now without NFL; Cardinals (MLB) dominate sports share but Blues hold solid #2.",
      onField: "Kyrou/Thomas core both at $8.125M AAV; Pavel Buchnevich anchor; post-2019 contention window has closed; rebuild orientation."
    }
  },

  "Winnipeg Jets": {
    extendedValuationHistory: [
      { year: 2004, value: 0.108, source: "Forbes (Atlanta Thrashers)", isEstimated: true },
      { year: 2005, value: 0.112, source: "Forbes (Atlanta Thrashers)" },
      { year: 2006, value: 0.123, source: "Forbes (Atlanta Thrashers)" },
      { year: 2007, value: 0.139, source: "Forbes (Atlanta Thrashers)" },
      { year: 2008, value: 0.150, source: "Forbes (Atlanta Thrashers)" },
      { year: 2009, value: 0.143, source: "Forbes (Atlanta Thrashers)" },
      { year: 2010, value: 0.135, source: "Forbes (Atlanta Thrashers)" },
      { year: 2011, value: 0.164, source: "Forbes (Thrashers/Jets relocation)" },
      { year: 2012, value: 0.200, source: "Forbes (Winnipeg Jets)" },
      { year: 2013, value: 0.220, source: "Forbes" },
      { year: 2014, value: 0.250, source: "Forbes" },
      { year: 2015, value: 0.305, source: "Forbes" },
      { year: 2016, value: 0.340, source: "Forbes" },
      { year: 2017, value: 0.358, source: "Forbes" },
      { year: 2018, value: 0.400, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian premium: Rogers Sportsnet + Bell national TV provides $40-60M vs. $19M US baseline; significant Canadian-team revenue advantage.",
      stadium: "Canada Life Centre (2004) — True North Sports & Entertainment owned (Chipman/Thomson families); compact 15,300 capacity is league's smallest.",
      brand: "Relocated from Atlanta 2011; reconstituted Jets brand with deep Manitoba heritage; sellout streak intact post-relocation.",
      marketSize: "Winnipeg DMA smallest in NHL; intense local engagement; David Thomson family (~$70B net worth) provides financial backstop.",
      onField: "Connor Hellebuyck Vezina-caliber goalie; Mark Scheifele core; Morrissey 8yr/$72M; small market punching at contender level recently."
    }
  },

  "Anaheim Ducks": {
    extendedValuationHistory: [
      { year: 2004, value: 0.112, source: "Forbes" },
      { year: 2005, value: 0.108, source: "Forbes" },
      { year: 2006, value: 0.157, source: "Forbes" },
      { year: 2007, value: 0.184, source: "Forbes" },
      { year: 2008, value: 0.207, source: "Forbes" },
      { year: 2009, value: 0.193, source: "Forbes" },
      { year: 2010, value: 0.188, source: "Forbes" },
      { year: 2011, value: 0.198, source: "Forbes" },
      { year: 2012, value: 0.215, source: "Forbes" },
      { year: 2013, value: 0.250, source: "Forbes" },
      { year: 2014, value: 0.300, source: "Forbes" },
      { year: 2015, value: 0.350, source: "Forbes" },
      { year: 2016, value: 0.395, source: "Forbes" },
      { year: 2017, value: 0.415, source: "Forbes" },
      { year: 2018, value: 0.450, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally/Diamond RSN exposure with Kings sharing local market; Samueli wealth provides operational stability.",
      stadium: "Honda Center (1993) — operated by Samuelis' OC Vibe project; new $4B Anaheim mixed-use district being built around arena is substantial valuation lever.",
      brand: "Modern Disney-founded (1993) franchise; rebranded from Mighty Ducks 2006; 2007 Stanley Cup; building current young identity.",
      marketSize: "Los Angeles DMA #2 — but Orange County subset; competes with Kings for Southern California fan share.",
      onField: "Trevor Zegras + Mason McTavish young core; Cutter Gauthier first-round picks compounding; rebuild approaching contention turn."
    }
  },

  "Calgary Flames": {
    extendedValuationHistory: [
      { year: 2004, value: 0.108, source: "Forbes" },
      { year: 2005, value: 0.118, source: "Forbes" },
      { year: 2006, value: 0.150, source: "Forbes" },
      { year: 2007, value: 0.179, source: "Forbes" },
      { year: 2008, value: 0.203, source: "Forbes" },
      { year: 2009, value: 0.214, source: "Forbes" },
      { year: 2010, value: 0.203, source: "Forbes" },
      { year: 2011, value: 0.202, source: "Forbes" },
      { year: 2012, value: 0.240, source: "Forbes" },
      { year: 2013, value: 0.310, source: "Forbes" },
      { year: 2014, value: 0.420, source: "Forbes" },
      { year: 2015, value: 0.450, source: "Forbes" },
      { year: 2016, value: 0.430, source: "Forbes" },
      { year: 2017, value: 0.450, source: "Forbes" },
      { year: 2018, value: 0.450, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian premium: Rogers/Bell national TV revenue significantly above US-only $19M; Sportsnet 360 carriage provides scale.",
      stadium: "Scotiabank Saddledome (1983) is NHL's oldest venue; new Culture & Entertainment District arena ($1.2B+ deal) under construction with 2027 target.",
      brand: "1989 Stanley Cup champions; deep Alberta hockey heritage; 'Battle of Alberta' rivalry with Oilers anchors regional engagement.",
      marketSize: "Calgary DMA #4 in Canada; oil/energy corporate base supports premium pricing; sole NHL franchise locally.",
      onField: "Jonathan Huberdeau contract burden; recent franchise direction seeking reset; Markstrom traded; transition window."
    }
  },

  "Edmonton Oilers": {
    extendedValuationHistory: [
      { year: 2004, value: 0.099, source: "Forbes" },
      { year: 2005, value: 0.105, source: "Forbes" },
      { year: 2006, value: 0.146, source: "Forbes" },
      { year: 2007, value: 0.166, source: "Forbes" },
      { year: 2008, value: 0.175, source: "Forbes" },
      { year: 2009, value: 0.183, source: "Forbes" },
      { year: 2010, value: 0.165, source: "Forbes" },
      { year: 2011, value: 0.181, source: "Forbes" },
      { year: 2012, value: 0.200, source: "Forbes" },
      { year: 2013, value: 0.225, source: "Forbes" },
      { year: 2014, value: 0.475, source: "Forbes" },
      { year: 2015, value: 0.475, source: "Forbes" },
      { year: 2016, value: 0.445, source: "Forbes" },
      { year: 2017, value: 0.520, source: "Forbes" },
      { year: 2018, value: 0.500, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian premium: Rogers/Bell national TV plus McDavid-Draisaitl marquee status drives outsized appearances and ad revenue.",
      stadium: "Rogers Place (2016) — $480M public/private split; Katz-owned operations; Ice District mixed-use development around arena adds significant ancillary value.",
      brand: "1980s dynasty (5 Cups Gretzky era) carries permanent national heritage; current McDavid era restoring contention-grade brand.",
      marketSize: "Edmonton DMA #5 in Canada; oil & gas corporate base; sole NHL franchise; passionate market endures losing seasons.",
      onField: "Connor McDavid 8yr/$100M (highest AAV in NHL); Leon Draisaitl 8yr/$112M; back-to-back Cup Final losses 2024-25; Cup window mature."
    }
  },

  "Los Angeles Kings": {
    extendedValuationHistory: [
      { year: 2004, value: 0.150, source: "Forbes" },
      { year: 2005, value: 0.157, source: "Forbes" },
      { year: 2006, value: 0.165, source: "Forbes" },
      { year: 2007, value: 0.190, source: "Forbes" },
      { year: 2008, value: 0.195, source: "Forbes" },
      { year: 2009, value: 0.193, source: "Forbes" },
      { year: 2010, value: 0.195, source: "Forbes" },
      { year: 2011, value: 0.232, source: "Forbes" },
      { year: 2012, value: 0.276, source: "Forbes" },
      { year: 2013, value: 0.420, source: "Forbes" },
      { year: 2014, value: 0.500, source: "Forbes" },
      { year: 2015, value: 0.575, source: "Forbes" },
      { year: 2016, value: 0.620, source: "Forbes" },
      { year: 2017, value: 0.700, source: "Forbes" },
      { year: 2018, value: 0.750, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Bally Sports SoCal RSN exposure; AEG empire scale provides cross-property marketing leverage.",
      stadium: "Crypto.com Arena (1999) — AEG-owned; Kings tenant alongside Lakers and Clippers; AEG keeps full venue economics; new Inglewood Intuit Dome (Clippers) reduces tenancy load.",
      brand: "1990s Gretzky-era brand boost; back-to-back Cups (2012, 2014) restored relevance; Hollywood-backed brand integration deepens reach.",
      marketSize: "Los Angeles DMA #2; massive corporate base; competes with Lakers, Dodgers, Rams for share but maintains affluent fanbase.",
      onField: "Anze Kopitar/Drew Doughty aging legacy core; Quinton Byfield emerging; recent first-round playoff exits frustrating Cup ambitions."
    }
  },

  "San Jose Sharks": {
    extendedValuationHistory: [
      { year: 2004, value: 0.122, source: "Forbes" },
      { year: 2005, value: 0.125, source: "Forbes" },
      { year: 2006, value: 0.135, source: "Forbes" },
      { year: 2007, value: 0.149, source: "Forbes" },
      { year: 2008, value: 0.165, source: "Forbes" },
      { year: 2009, value: 0.168, source: "Forbes" },
      { year: 2010, value: 0.161, source: "Forbes" },
      { year: 2011, value: 0.176, source: "Forbes" },
      { year: 2012, value: 0.205, source: "Forbes" },
      { year: 2013, value: 0.245, source: "Forbes" },
      { year: 2014, value: 0.290, source: "Forbes" },
      { year: 2015, value: 0.355, source: "Forbes" },
      { year: 2016, value: 0.385, source: "Forbes" },
      { year: 2017, value: 0.470, source: "Forbes" },
      { year: 2018, value: 0.490, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; NBC Sports California carriage; Bay Area tech corporate base supports premium pricing.",
      stadium: "SAP Center (1993) — city-owned; Sharks operate via long-term lease; corporate sponsorship embedded with Bay Area tech ecosystem.",
      brand: "Modern (1991) franchise without Cup; 'Sharks' identity strong locally; brand depth limited by no championship.",
      marketSize: "San Francisco-Oakland-San Jose DMA #6; tech-heavy affluent fanbase but competes with Warriors/Giants/49ers/A's-Kraken for sports calendar.",
      onField: "Macklin Celebrini 2024 #1 pick is generational; major rebuild underway; Erik Karlsson era ended; Will Smith emerging."
    }
  },

  "Seattle Kraken": {
    extendedValuationHistory: [
      { year: 2021, value: 0.875, source: "Forbes (post-expansion fee)" },
      { year: 2022, value: 0.950, source: "Forbes" },
      { year: 2023, value: 1.10, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; ROOT Sports NW carriage (Bonderman/MLB Mariners JV); RSN-collapse-immune via vertical structure.",
      stadium: "Climate Pledge Arena (2021) — $1.15B 100% privately financed renovation by Oak View Group/Kraken ownership; carbon-neutral first in NHL; Amazon naming.",
      brand: "Newest franchise (2021) with strong launch design and merch (S/Kraken logo viral); brand still being established; identity resonates with Pacific Northwest.",
      marketSize: "Seattle DMA #12 — affluent tech corporate base (Amazon, Microsoft); no NBA team yet; sole NHL franchise.",
      onField: "Matty Beniers 2022 #2 pick anchors; 2023 second-round playoff run; rebuilding from 2024-25 setback; salary-cap-friendly roster."
    }
  },

  "Vancouver Canucks": {
    extendedValuationHistory: [
      { year: 2004, value: 0.151, source: "Forbes" },
      { year: 2005, value: 0.166, source: "Forbes" },
      { year: 2006, value: 0.198, source: "Forbes" },
      { year: 2007, value: 0.231, source: "Forbes" },
      { year: 2008, value: 0.252, source: "Forbes" },
      { year: 2009, value: 0.262, source: "Forbes" },
      { year: 2010, value: 0.262, source: "Forbes" },
      { year: 2011, value: 0.300, source: "Forbes" },
      { year: 2012, value: 0.342, source: "Forbes" },
      { year: 2013, value: 0.500, source: "Forbes" },
      { year: 2014, value: 0.700, source: "Forbes" },
      { year: 2015, value: 0.745, source: "Forbes" },
      { year: 2016, value: 0.760, source: "Forbes" },
      { year: 2017, value: 0.735, source: "Forbes" },
      { year: 2018, value: 0.620, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Canadian premium: Rogers/Bell national TV revenue plus Sportsnet Pacific provides scale beyond US baseline; bilingual/multicultural Vancouver market.",
      stadium: "Rogers Arena (1995) — Aquilini Group privately owned; team-owned full venue economics; some non-hockey concert revenue.",
      brand: "1970-founded franchise; no Stanley Cup despite 1994/2011 Final appearances; passionate fanbase; brand carries strong Pacific Northwest identity.",
      marketSize: "Vancouver DMA #3 in Canada; affluent and culturally diverse; sole NHL franchise locally; high cost of living matches premium ticket pricing.",
      onField: "Quinn Hughes Norris-caliber defenseman; Elias Pettersson 8yr/$92.8M; Cup window emerging but not yet realized."
    }
  },

  "Vegas Golden Knights": {
    extendedValuationHistory: [
      { year: 2017, value: 0.500, source: "Forbes (expansion fee)" },
      { year: 2018, value: 0.575, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "~$19M/yr national share; Scripps/AT&T SportsNet RM carriage; Las Vegas market growing in scale and TV value with multi-sport tourism.",
      stadium: "T-Mobile Arena (2016) — privately financed by AEG/MGM Resorts JV; Knights tenant with favorable economics; iconic Las Vegas Strip location.",
      brand: "Modern (2017) franchise with fastest expansion-to-Cup-win in pro sports history (2023); Vegas-centric marketing innovation; major brand from launch.",
      marketSize: "Las Vegas DMA #40 — but tourism scale (~40M visitors/yr) and sports-betting ecosystem create unique market dynamics; sole NHL franchise.",
      onField: "2023 Stanley Cup champions; Jack Eichel/Mark Stone core; aggressive cap management; Cup window remains open."
    }
  },

};

export default nhlSupplements
